import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Calendar } from 'lucide-react';
export function CTASlide() {
  return <div className="h-full w-full flex flex-col items-center justify-start md:justify-center px-4 md:px-8 bg-[#11166b] relative overflow-y-auto md:overflow-hidden py-16 md:py-0" data-id="element-19">
      {/* Background gradients */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-20">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] md:w-[600px] h-[300px] md:h-[600px] bg-[#00d8a8]/20 rounded-full blur-[100px]" data-id="element-21" />
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8
    }} className="text-center relative z-10 max-w-4xl mt-8 md:mt-0" data-id="element-22">
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 md:mb-8 tracking-tight" data-id="element-23">
          Ready to Scale?
        </h2>
        <p className="text-xl md:text-2xl lg:text-3xl text-slate-300 mb-8 md:mb-12 font-light" data-id="element-24">
          Let's discuss how we can optimize your operations and future-proof
          your business.
        </p>

        <motion.a href="https://scoptvision.odoo.com/r/mta" target="_blank" rel="noopener noreferrer" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} className="group relative inline-flex items-center gap-3 px-6 py-3 md:px-8 md:py-4 bg-[#00d8a8] hover:bg-[#00c49a] text-[#11166b] text-lg md:text-xl font-bold rounded-full transition-all shadow-lg shadow-[#00d8a8]/30" data-id="element-25">
          <span data-id="element-26">Start for free</span>
          <ArrowRight className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" data-id="element-27" />
        </motion.a>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.5,
      duration: 0.8
    }} className="absolute bottom-8 md:bottom-12 text-slate-400 text-xs md:text-sm" data-id="element-28">
        © 2026 Scoptvision. All rights reserved.
      </motion.div>
    </div>;
}